var ImageScroll = new Swiper(".section-image-scroll", {
  slidesPerView: "auto",
  spaceBetween: 16,
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false
  },
  freeMode: {
    enabled: true,
    momentum: false,
  },
  allowTouchMove: false,
});


var Testimonial = new Swiper(".testimonial-slider", {
  slidesPerView: 1.2,
  spaceBetween: 16,
  navigation: {
    nextEl: ".testimonial-section .swiper-button-next",
    prevEl: ".testimonial-section .swiper-button-prev",
  },
  breakpoints: {
    750: {
      slidesPerView: 1.8,
      spaceBetween: 16
    },
    990: {
      slidesPerView: 2.8,
      spaceBetween: 16
    }
  }
});

var CS_testimonial = new Swiper(".cs-testimonial-slider", {
  slidesPerView: 1.5,
  spaceBetween: 16,
  centeredSlides: true,
  roundLengths: true,
  loop: true,
  navigation: {
    nextEl: ".cs-testimonial-section .swiper-button-next",
    prevEl: ".cs-testimonial-section .swiper-button-prev",
  },
  breakpoints: {
    750: {
      slidesPerView: 1.8,
      spaceBetween: 20
    },
    990: {
      slidesPerView: 2.2,
      spaceBetween: 16
    }
  }
});

// Keep only one <details> open inside each .shopify-section
document.querySelector('#MainContent').addEventListener('click', (e) => {
  const summary = e.target.closest('summary');
  if (!summary) return;

  const currentDetails = summary.closest('details');
  if (!currentDetails) return;

  const section = currentDetails.closest('.shopify-section') || document;

  if (!currentDetails.hasAttribute('open')) {
    section.querySelectorAll('details[open]').forEach(d => {
      if (d !== currentDetails) d.removeAttribute('open');
    });
  }
});



document.querySelectorAll('.flight-arrival-time').forEach(function(el) {
    const text = el.textContent.trim();
    const removeText = '[following day]';

    if (text.includes(removeText)) {
        el.setAttribute('data-text', removeText);
        el.textContent = text.replace(removeText, '').trim();
    }
});


document.addEventListener("click", function (e) {
  const header = e.target.closest(".pi-header");
  if (!header) return; // click wasn't on a header
  let fieldGroup = header.nextElementSibling;
  if (!fieldGroup || !fieldGroup.classList.contains("pi-fild-group")) {
    fieldGroup = header.parentElement?.querySelector(".pi-fild-group");
  }

  if (fieldGroup) {
    fieldGroup.classList.toggle("active");
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const faqLists = document.querySelectorAll(".tab-faq-list");

  tabButtons.forEach(button => {
    button.addEventListener("click", function () {
      const target = this.dataset.faqTitle;
      tabButtons.forEach(btn => btn.classList.remove("active"));
      faqLists.forEach(list => list.classList.remove("active"));
      this.classList.add("active");

      faqLists.forEach(list => {
        if (list.dataset.faqContent === target) {
          list.classList.add("active");
        }
      });
    });
  });
});




 var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// $(".quantity__button").on("click",function(){
//   var fix_value = parseInt($("#pro_qty_total").attr("value"), 10); 
//   var value = parseInt($(".quantity__input").val(), 10);
//   var diff = fix_value - value;
//   var unit_price = parseFloat($(".ticket-summary-details.tickit_price").attr("data-price")); 
//   var total_price = unit_price * value; 

//   $(".tickets-left-count-text").text(diff);
//   if (value >= fix_value) {
//     $(".quantity__button[name='plus']").addClass("disabled");
//   } else {
//     $(".quantity__button[name='plus']").removeClass("disabled");
//   }

//     var price_totle = Shopify.formatMoney(total_price, '${{amount}}');
//     $(".ticket-summary-details.tickit_price").text(price_totle);
//     $(".ticket-summary-details.ticket_count.final-price").text(price_totle);

//     var HtmlForm = $(".Newadd_passenger").html();
//     if (this.getAttribute("name") === "plus") {
//       if (value > $(".passenger-detail-row .Newadd_passenger").length) {
//         $(".passenger-detail-row").append("<div class='Newadd_passenger'>" + HtmlForm + "</div>");
//       }
//     } else if (this.getAttribute("name") === "minus") {
//       var currentForms = $(".passenger-detail-row .Newadd_passenger").length;
//       if (currentForms > 1) {
//         $(".passenger-detail-row .Newadd_passenger:last").remove();
//       }
//     }
// });


document.querySelectorAll(".quantity__button").forEach(function (btn) {
  btn.addEventListener("click", function () {
    var fix_value = parseInt(document.querySelector("#pro_qty_total").getAttribute("value"), 10);
    var value = parseInt(document.querySelector(".quantity__input").value, 10);
    var diff = fix_value - value;
    var unit_price = parseFloat(document.querySelector(".ticket-summary-details.tickit_price").getAttribute("data-price"));
    var total_price = unit_price * value;

    // update tickets left
    document.querySelector(".tickets-left-count-text").textContent = diff;

    // disable / enable plus button
    var plusBtn = document.querySelector(".quantity__button[name='plus']");
    if (value >= fix_value) {
      plusBtn.classList.add("disabled");
    } else {
      plusBtn.classList.remove("disabled");
    }

    // format price and update
    var price_total = Shopify.formatMoney(total_price, "${{amount}}");
    document.querySelector(".ticket-summary-details.tickit_price").textContent = price_total;
    document.querySelector(".ticket-summary-details.ticket_count.final-price").textContent = price_total;

    // passenger form handling
    var HtmlForm = document.querySelector(".Newadd_passenger").innerHTML;
    var passengerRow = document.querySelector(".passenger-detail-row");
    var currentForms = passengerRow.querySelectorAll(".Newadd_passenger").length;

    if (this.getAttribute("name") === "plus") {
      if (value > currentForms) {
        var newDiv = document.createElement("div");
        newDiv.classList.add("Newadd_passenger");
        newDiv.innerHTML = HtmlForm;
        passengerRow.appendChild(newDiv);
      }
    } else if (this.getAttribute("name") === "minus") {
      if (currentForms > 1) {
        passengerRow.querySelector(".Newadd_passenger:last-child").remove();
      }
    }

  document.querySelectorAll('.date-field').forEach(wrapper => {
    const input = wrapper.querySelector('input');
    function toggle() {
      if (input.value) wrapper.classList.add('has-value');
      else wrapper.classList.remove('has-value');
    }
    input.addEventListener('input', toggle);
    input.addEventListener('change', toggle);
    input.addEventListener('focus', () => wrapper.classList.add('focused'));
    input.addEventListener('blur', () => wrapper.classList.remove('focused'));
    toggle();
    setTimeout(toggle, 50);
  });
  });

});



$(document).on('click', 'a[href^="#"]', function(e) {
  e.preventDefault();

  var target = $($(this).attr('href'));
  if (target.length) {
    var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    $('html, body').animate({
      scrollTop: target.offset().top - headerHeight
    }, 600); // 600ms = animation speed
  }
});
